var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7 1h10a2 2 0 0 1 1.995 1.85L19 3v18a2 2 0 0 1-1.85 1.995L17 23H7a2 2 0 0 1-1.995-1.85L5 21V3a2 2 0 0 1 1.85-1.995L7 1h10zm10 2H7v18h10zm-5 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }